import { Button } from "@msuite/ui/button";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { createStandardMenuItems, Menu } from "@msuite/ui/menu";
import { ConfirmModal, ModalWrapper, useAsyncModal } from "@msuite/ui/modal";
import { useQueryClient } from "@msuite/ui/query";
import { type CellContext, RowActionsWrapper, useDataTableContext } from "@msuite/ui/table";
import type { CalculationMemberListItem } from "@msuite/utils/types";
import React from "react";
import { client } from "@/hono";

export function CalculationFormMembersRowActions({
	cell,
}: CellContext<CalculationMemberListItem, "actions">) {
	/** Context */
	const { queryKey } = useDataTableContext();

	/** Hooks */
	const { t } = useTranslation();
	const qc = useQueryClient();
	const asyncModal = useAsyncModal();
	const calculationId = cell.row.original.serviceCalculationId;
	const userId = cell.row.original.userId;

	/** Functions */
	async function handleOnDeleteMember() {
		if (!queryKey) return;
		const isConfirmed = await asyncModal.confirm();
		if (!isConfirmed) return;
		await client.calculations[":calculationId"].members[":userId"].$delete({
			param: { calculationId, userId },
		});
		await qc.invalidateQueries({ queryKey });
	}

	/** Render */
	return (
		<React.Fragment>
			<RowActionsWrapper to={null}>
				<Menu items={createStandardMenuItems({ onDelete: handleOnDeleteMember })}>
					<Button
						size="xxs"
						icon={<Icon name="EllipsisVertical" />}
						variant="ghost"
					/>
				</Menu>
			</RowActionsWrapper>
			<ModalWrapper>
				{asyncModal.isOpen && (
					<ConfirmModal
						controller={asyncModal}
						message={t("calculations.delete_calculation_member_confirm_message")}
					/>
				)}
			</ModalWrapper>
		</React.Fragment>
	);
}
